import styled from 'styled-components';

export const $MobileSearchBar = styled.div<{ $hasTopMargin?: boolean }>`
  margin-top: ${({ $hasTopMargin }) => ($hasTopMargin ? '1rem' : '0')};
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const $MobileSearchRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
`;

export const $MobileSearchInputWrap = styled.div`
  flex: 1;
  min-width: 0;
`;

export const $ScanButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-height: 44px;
  padding: 0;
  border: 1px solid
    ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#ccd2f9'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.smallRadius ?? '4px'};
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    border-color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f5f7ff'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
